import React from 'react'
import { Drawer, Box, Typography } from '@mui/material'

import { DrawerType } from 'src/views/Onboarding/LearnPage/useOnboardingStack'

import { CloseDrawer } from '../../../common/icons/closeDrawer'

import ImportEmployeesView from './drawerContents/ImportEmployeesView'
import VerifyDomainsView from './drawerContents/VerifyDomainsView'
import EnsureEmailsView from './drawerContents/EnsureEmailsView'
import LaunchCampaignView from './drawerContents/LaunchCampaignView'

export default function OnboardingDrawer({
  open,
  onClose,
  drawerType,
  currentStepDetails,
  completeStepAndProceed,
  toggleStepCompletion
}) {
  const title = drawerTitleMap[drawerType] || 'Onboarding Step'
  const commonProps = {
    onClose,
    currentStepDetails,
    completeStepAndProceed,
    toggleStepCompletion
  }

  return (
    <>
      {open && (
        <Box sx={closeButtonContainerSx} onClick={onClose}>
          <CloseDrawer />
        </Box>
      )}
      <Drawer
        anchor='right'
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: drawerPaperSx
        }}
      >
        <Box sx={titleWrapperSx}>
          <Typography variant='h6' component='div' sx={titleSx}>
            {title}
          </Typography>
        </Box>
        <Box sx={contentWrapperSx}>{getDrawerContent(drawerType, commonProps)}</Box>
      </Drawer>
    </>
  )
}

const drawerWidth = 800

const closeButtonContainerSx = {
  position: 'fixed',
  top: '28px',
  right: `${drawerWidth + 24}px`,
  zIndex: theme => theme.zIndex.drawer + 1,
  cursor: 'pointer'
}

const drawerTitleMap = {
  [DrawerType.IMPORT_EMPLOYEES_DRAWER]: 'Import Employees',
  [DrawerType.VERIFY_DOMAINS_DRAWER]: 'Verify Domains',
  [DrawerType.ENSURE_EMAILS_DRAWER]: 'Ensure Email Delivery',
  [DrawerType.LAUNCH_CAMPAIGN_DRAWER]: 'Launch Your First Campaign',
  [DrawerType.SKIP_LAUNCH_CAMPAIGN_ACTION]: 'Skip Campaign Launch'
}

const getDrawerContent = (drawerType, commonProps) => {
  switch (drawerType) {
    case DrawerType.IMPORT_EMPLOYEES_DRAWER:
      return <ImportEmployeesView {...commonProps} />
    case DrawerType.VERIFY_DOMAINS_DRAWER:
      return <VerifyDomainsView {...commonProps} />
    case DrawerType.ENSURE_EMAILS_DRAWER:
      return <EnsureEmailsView {...commonProps} />
    case DrawerType.LAUNCH_CAMPAIGN_DRAWER:
      return <LaunchCampaignView {...commonProps} />
    default:
      return <Box sx={{ p: 3 }}></Box>
  }
}

const drawerPaperSx = {
  width: drawerWidth,
  maxWidth: '100vw',
  borderTopLeftRadius: '16px',
  borderBottomLeftRadius: '16px',
  boxShadow: ' 0px 4px 60px 0px #1B1B2659',
  backgroundColor: '#F8F8FB',
  padding: 2,
  display: 'flex',
  flexDirection: 'column',
  height: '100vh'
}

const contentWrapperSx = {
  flexGrow: 1,
  overflowY: 'auto',
  p: 0
}

const titleSx = {
  fontSize: '35px',
  fontWeight: '900',
  fontFamily: 'Satoshi',
  color: '#1B1B26'
}

const titleWrapperSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  p: '12px 20px'
}
